/**
 * Created by seaasun on 2017/12/8.
 */
import Vue from 'vue'
import _ from 'lodash'
import utils from '@/assets/utils'

/*
## GEO
### addAddress
### addGeo
### deleteGeo: delete geo and address
### cleanGeo: clean geo and address

## Common
### updateDesiredQty
### saveListType
### saveOrder

## Phone Option
### savePhoneOption

## Demo
### saveDemoType
### setAllHouseholds
### setUnAllHouseholds
### addNewDemo
### addNewDemoValue
### deleteDemo
### deleteDemoValue
### deleteDemoColumnName
### clearDemos

 */
export default {
  /* ## GEO */
  addAddress (state, item) {
    // add address for order.OrderAddress
    let address = {
      AddrSearchString: '',
      AddrUsageType: 2,
      AddressLine: '',
      AddressName: '',
      CityName: '',
      CountryCode: '',
      Latitude: '',
      Longitude: '',
      Quantity: 0,
      Radius: 0,
      StateCode: '',
      SameState: false
    }
    for (let key of Object.keys(item)) {
      if (address.hasOwnProperty(key)) {
        address[key] = item[key]
      }
    }
    let isExist = false
    // deduplication checkout
    for (let key of Object.keys(state.OrderAddresses)) {
      if (state.OrderAddresses[key].AddrUsageType === 2 && state.OrderAddresses[key].AddrSearchString.split(':')[0] === address.AddrSearchString.split(':')[0] && state.OrderAddresses[key].AddrSearchString.split(':')[1] === address.AddrSearchString.split(':')[1]) {
        // state.OrderAddresses[key] = address
        Vue.set(state.OrderAddresses, key, address)
        isExist = true
      }
    }
    if (!isExist) {
      state.OrderAddresses.push(address)
    }
  },
  updateAddress (state, item) {
    for (let key of Object.keys(state.OrderAddresses)) {
      if (state.OrderAddresses[key].AddrSearchString === item.oldAddrSearchString) {
        Vue.set(state.OrderAddresses[key], 'AddrSearchString', item.AddrSearchString)
        Vue.set(state.OrderAddresses[key], 'Radius', item.Radius)
      }
    }
  },
  updateGeo (state, item) {
    for (let key of Object.keys(state.OrderGeos)) {
      if (state.OrderGeos[key].GeoKeyCode === item.oldGeoKeyCode) {
        Vue.set(state.OrderGeos[key], 'GeoKeyCode', item.GeoKeyCode)
        Vue.set(state.OrderGeos[key], 'AddressLine', item.GeoKeyCode)
      }
    }
  },
  addGeo (state, item) {
    // add geo for order.OrderGeos
    // item: {}  geo
    let geo = {
      AddressLine: '',
      AvailableQty: 0,
      CityName: '',
      CountryCode: 'US',
      CountyFips: '',
      CountyCode: '',
      CostPrice: null,
      GeoKeyCode: null,
      GeoKeyDesc: null,
      CountyName: null,
      GeoType: 0,
      StateCode: '',
      OrderGeoDetails: null
    }

    for (let key of Object.keys(item)) {
      if (geo.hasOwnProperty(key)) {
        geo[key] = item[key]
      }
    }
    // deduplication checkout
    let isExist = false
    for (let key of Object.keys(state.OrderGeos)) {
      if (typeof (state.OrderGeos[key].GeoKeyCode) === 'string') {
        state.OrderGeos[key].GeoKeyCode = state.OrderGeos[key].GeoKeyCode || ''
        geo.GeoKeyCode = geo.GeoKeyCode || ''
        geo.GeoKeyCode += ''
        if (state.OrderGeos[key].GeoKeyCode.split(':').length > 0 &&
          geo.GeoKeyCode.split(':').length > 0 &&
          state.OrderGeos[key].GeoKeyCode.split(':')[0] === geo.GeoKeyCode.split(':')[0] &&
          state.OrderGeos[key].GeoKeyCode.split(':')[1] === geo.GeoKeyCode.split(':')[1]) {
          Vue.set(state.OrderGeos, key, geo)
          isExist = true
        }
      }
    }
    if (!isExist) {
      state.OrderGeos.push(geo)
    }
  },
  deleteGeo (state, code) {
    /* delete geo and address */
    if (code.GeoKeyCode) {
      code = code.GeoKeyCode
    }
    for (let i = 0; i < state.OrderAddresses.length; i++) {
      if (state.OrderAddresses[i].AddrSearchString === code) {
        Vue.delete(state.OrderAddresses, i)
      }
    }
    for (let i = 0; i < state.OrderGeos.length; i++) {
      if (state.OrderGeos[i].GeoKeyCode === code) {
        Vue.delete(state.OrderGeos, i)
      }
    }
  },
  cleanGeo (state, val) {
    if (val) {
      let geos = _.filter(state.OrderGeos, function (o) { return o.GeoType !== val })
      geos = geos || []
      Vue.set(state, 'OrderGeos', geos)
      state.OrderAddresses = []
    } else {
      state.RadiusTypeChoice = 1
      state.OrderAddresses = []
      state.OrderGeos = []
    }
  },
  UpdateAddressSameState (state, val) {
    for (let i = 0; i < state.OrderAddresses.length; i++) {
      state.OrderAddresses[i].SameState = val
    }
  },
  // ## PhoneOption
  savePhoneOption (state, val) {
    state.PhoneOption = val
  },
  saveEmailOption (state, val) {
    state.EmailOption = val
  },
  /* ## Demo */
  saveDemoType (state, val) {
    // @val int,   99:All  1:others
    state.DemoType = val
  },
  setAllHouseholds (state) {
    state.DemoType = 99
  },
  setUnAllHouseholds (state) {
    state.DemoType = 1
  },
  addNewDemo (state, payload) {
    // @payload {}
    state.OrderSelectedDemos.push(payload)
  },
  addNewDemoValue (state, payload) {
    // @payload { index: int, val: {}
    state.OrderSelectedDemos[payload.index].Values.push(payload.val)
  },
  deleteDemo (state, payload) {
    Vue.delete(state.OrderSelectedDemos, payload)
  },
  deleteDemoValue (state, payload) {
    // @payload { index: int, valIndex: int
    Vue.delete(state.OrderSelectedDemos[payload.index].Values, payload.valueIndex)
  },
  deleteDemoColumnName (state, columnName) {
    for (let item in state.OrderSelectedDemos) {
      if (state.OrderSelectedDemos[item].ColumnName === columnName) {
        Vue.delete(state.OrderSelectedDemos, item)
      }
    }
  },
  clearDemos (state) {
    state.OrderSelectedDemos = []
  },
  /* ## Common */
  updateDesiredQty (state, payload) {
    let item = state.OrderGeos[payload.index]
    let qty = parseInt(payload.qty)

    // check available qty
    if (!item.AvailableQty) {
      item.AvailableQty = state.TotalAvailableQty
    }

    // check qty
    if (isNaN(qty)) {
      qty = item.AvailableQty
    } else if (qty > item.AvailableQty) {
      qty = item.AvailableQty
    } else if (qty < 0) {
      qty = 0
    }

    if (state.OrderGeos.length === 0) {
      state.TotalDesiredQty = qty
    } else {
      // save qty
      item.DesiredQty = qty

      var left = qty
      if (item.OrderGeoDetails && item.OrderGeoDetails.length > 0) {
        var geoDetails = item.OrderGeoDetails
        for (var j = 0; j < geoDetails.length; j++) {
          if (left <= 0) {
            geoDetails[j].DesiredQty = 0
          } else {
            if (geoDetails[j].AvailableQty >= left) {
              geoDetails[j].DesiredQty = left
            } else if (geoDetails[j].AvailableQty > 0) {
              geoDetails[j].DesiredQty = geoDetails[j].AvailableQty
            }
            left = left - geoDetails[j].DesiredQty
          }
        }
      }

      // calcuate total
      let total = 0
      for (let geo of state.OrderGeos) {
        total += geo.DesiredQty
      }
      state.TotalDesiredQty = total
    }
  },
  saveListType (state, val) {
    // TODO@PONY many save don't use this function
    state.ListType = parseInt(val)
    // state.OrderType = parseInt(val)
  },
  saveOrder (state, values) {
    if (values) {
      for (let key of Object.keys(values)) {
        if (values[key] !== null) {
          Vue.set(state, key, values[key])
        }
      }
    }
  },
  saveKey (state, val) {
    Vue.set(state, val[0], val[1])
  },
  updateContactInformation (state, values) {
    Vue.set(state.OrderContactInformation, values.key, values.val)
  },
  updatePaymentInformation (state, values) {
    Vue.set(state.OrderPaymentInformation, values.key, values.val)
  },
  saveAdditionalOutputColumns (state, values) {
    state.AdditionalOutputColumns = values
  },
  clearElementsForPricing (state) {
    state.ElementsForPricing = []
  },
  addElementsForPricing (state, item) {
    let price = {
      ElementDescription: null,
      ElementName: '',
      InternalPrice: 0,
      IsAdditional: false,
      IsGlobal: false,
      IsMultiple: true,
      NotificationRequired: false,
      Price: 0,
      PriceListName: '',
      SubColumnName: '',
      ValuesCount: 1,
      isInternalPrice: 0
    }

    for (let key of Object.keys(item)) {
      if (price.hasOwnProperty(key)) {
        price[key] = item[key]
      }
    }
    state.ElementsForPricing.push(price)
  },
  saveGeoDesiredQty (state, payload) {
    Vue.set(state.OrderGeos[payload.index].OrderGeoDetails[0], 'DesiredQty', payload.val)
  },
  addOrderSuppressions (state, item) {
    state.OrderSuppressions.push({
      OriginalOrderId: item.OrderId,
      SuppressedOrderCode: item.OrderCode,
      SuppressedOrderDesc: item.OrderDesc,
      SuppressedOrderId: item.OrderId,
      SuppressionName: item.OrderDesc,
      SuppressionValue: item.OrderCode
    })
  },
  addSaveCountSuppressions (state, item) {
    state.SaveCountSuppressions.push({
      OriginalCountId: item.OrderId,
      SuppressedCountCode: item.OrderCode,
      SuppressedCountDesc: item.OrderDesc,
      SuppressedCountId: item.OrderId,
      SuppressionName: item.OrderDesc,
      SuppressionValue: item.CountId
    })
  },
  // TODO@PONY need check
  addCustomSuppressions (state, item) {
    state.CustomSuppressions.push({
      FileName: item.SuppressionDesc,
      OrderDate: utils.dateFormat(item.OrderDate, 'MM/DD/YYYY'),
      SuppressionName: item.SuppressionName,
      SuppressionValue: item.SuppressionValue
    })
  },
  cleanSuppressions (state, item) {
    if (item === 'slc') {
      state.CustomSuppressions = []
    } else if (item === 'order') {
      state.OrderSuppressions = []
    }
  },
  removeOrderSuppressions (state, item) {
    for (let i = 0; i < state.OrderSuppressions.length; i++) {
      if (item.value === state.OrderSuppressions[i].SuppressionValue) {
        Vue.delete(state.OrderSuppressions, i)
      }
    }
  },
  removeSaveCountSuppressions (state, item) {
    for (let i = 0; i < state.SaveCountSuppressions.length; i++) {
      if (item.value === state.SaveCountSuppressions[i].SuppressionValue) {
        Vue.delete(state.SaveCountSuppressions, i)
      }
    }
  },
  // TODO@PONY need check
  removeCustomSuppressions (state, item) {
    for (let i = 0; i < state.CustomSuppressions.length; i++) {
      if (item.value === state.CustomSuppressions[i].SuppressionValue) {
        Vue.delete(state.CustomSuppressions, i)
      }
    }
  },
  tiggerGeoShowDetail (state, index) {
    let ordergeos = state.OrderGeos
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === index) {
        let showDetail = ordergeos[index].showDetail || false
        showDetail = !showDetail
        Vue.set(ordergeos[index], 'showDetail', showDetail)
      }
    }
  },
  changeGeoType (state, geoType) {
    Vue.set(state, 'GeoType', geoType)
    Vue.set(state, 'ZipType', 0)
    for (let i = 0; i < state.OrderGeos.length; i++) {
      Vue.set(state.OrderGeos[i], 'GeoType', geoType)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/order/mutations.js